import React, { useContext, useEffect, useState } from 'react';
import HeavySetDataContext from '../../context/HeavySetDataContext';
import UserSettingsContext from '../../context/UserSettingsContext';
import { urlSlug, setExercisePR } from '../../data/helpers';
import { Col, Row } from '../../styles/Grid';
import Card from './Card';
import Calendar from '../Charts/Calendar';
import { DataTable, DataTableHeader, DataTableRow, DataTableHeading, DataTableBody, DataTableCell } from '../Workouts/SingleWorkout';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

const Title = styled.h1`
  font-size: 2rem;
  font-weight: 900;
  letter-spacing: -2px;
  text-transform: uppercase;
`;

const Summary = ({ numOfWorkouts, exercises }) => {
  const data = useContext(HeavySetDataContext);
  const { units } = useContext(UserSettingsContext);
  const [currentYear, setCurrentYear] = useState(null);

  const workoutsCompleted = data.map(d => {
    return {
      day: d.date,
      value: d.workout,
    }
  });

  const years = [...new Set(data.map(d => d.date.split('-')[0]))];

  const getExercisePRs = (exercise, data) => {
    const filteredExerciseData = data.filter(ex => Object.keys(ex.exercises).includes(exercise));
    const pr = setExercisePR(filteredExerciseData, exercise);
    return {
      ...pr,
      exercise
    }
  }

  const exercisePRData = exercises.map(e => getExercisePRs(e, data));

  useEffect(() => {
    if (!currentYear) {
      setCurrentYear(years[years.length -1])
    }
  }, [currentYear, years]);

  return (
    <>
      <Title>Dashboard</Title>

      <Row>
        <Col size={1}>
          <Card>
            <h3 className="Card__title">Number of workouts completed: {numOfWorkouts}</h3>

            <div style={{ height: 184 }}>
              <div style={{ display: "flex", justifyContent: "center" }}>
                {
                  years && years.map(year => (
                    <div
                      key={year}
                      style={{ padding: "0 .5rem", fontWeight: year === currentYear ? "bold" : "normal", cursor: "pointer" }}
                      onClick={() => setCurrentYear(year)}
                    >
                      {year}
                    </div>
                  ))
                }
              </div>

              <Calendar data={workoutsCompleted} currentYear={currentYear} />
            </div>
          </Card>
        </Col>
      </Row>

      <Row>
        <Col size={1}>
          <Card>
            <h3 className="Card__title">Exercise PR's</h3>
            <DataTable>
              <DataTableHeader>
                <DataTableRow>
                  <DataTableHeading>Exercise</DataTableHeading>
                  <DataTableHeading>PR</DataTableHeading>
                  <DataTableHeading>Reps</DataTableHeading>
                  <DataTableHeading>Date</DataTableHeading>
                </DataTableRow>
              </DataTableHeader>
              <DataTableBody>
                {
                  exercisePRData.map(row => (
                    <DataTableRow key={`${row.date}-${row.exercise}`}>
                      <DataTableCell>
                        <Link
                          className="DataTableLink"
                          to={{
                            pathname: `/exercises/${urlSlug(row.exercise)}`,
                            state: { exercise: row.exercise },
                          }}
                        >
                          {row.exercise}
                        </Link>
                      </DataTableCell>
                      <DataTableCell>{row[units]}{units}</DataTableCell>
                      <DataTableCell>{row.reps}</DataTableCell>
                      <DataTableCell>{new Date(row.date).toLocaleDateString()}</DataTableCell>
                    </DataTableRow>
                  ))
                }
              </DataTableBody>
            </DataTable>
          </Card>
        </Col>
      </Row>
    </>
  );
}

export default Summary;
